import api from "@/lib/api";

const fileName = (r) =>
  `${r?.report_type === "jobb" ? "Jobbrapport" : "Servicerapport"}_${r?.report_number || r?.id}.pdf`;

async function fetchPdfBlob(reportId) {
  const res = await api.get(`/reports/${reportId}/pdf`, { responseType: "blob" });
  return new Blob([res.data], { type: "application/pdf" });
}

/** Download the PDF to the device. */
export async function downloadReportPdf(report) {
  const r = typeof report === "string" ? { id: report } : report;
  const blob = await fetchPdfBlob(r.id);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName(r);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 2000);
}

/** Open the PDF in a new tab (preview). Returns the object URL. */
export async function openReportPdf(report) {
  const r = typeof report === "string" ? { id: report } : report;
  const blob = await fetchPdfBlob(r.id);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener");
  return url;
}

/** Sample PDF rendered with the current company profile (settings page). */
export async function openSamplePdf() {
  const res = await api.get("/settings/company/sample-pdf", { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank", "noopener");
  return url;
}
